import { useMemo } from 'react';
import { useStore } from 'zustand-lib/storeGlobal';
import { EnumAppSettings } from 'constants/Enums/app-settings';
import { CART_OPTIMIZE_URL, PRODUCT_CATALOG } from 'constants/Paths';

const fallback = {
  timer: 1000 * 60 * 5, // 5 minutes
  excludes: ['/dashboard'],
};

// Trang tối ưu giỏ hàng có màn chờ dài, không được đá về dashboard
const alwaysExcludes = [PRODUCT_CATALOG, CART_OPTIMIZE_URL];

export const useGetDashboardRedirectTimerConfig = (platform = 'web') => {
  const appSetting = useStore((state: any) => state.appSetting);
  // example of appSetting: { "DASHBOARD_REDIRECT_TIMER": { "web": { "timer": 3... } } }
  const timerConfig = appSetting?.[EnumAppSettings.DASHBOARD_REDIRECT_TIMER]?.[platform];

  // default in config will be minutes, so we need to convert it to milliseconds
  const timerByMinute = Number(timerConfig?.timer) * 1000 * 60;
  const configExcludes = timerConfig?.excludes?.length ? timerConfig.excludes : fallback.excludes;
  const excludes = useMemo(() => [...configExcludes, ...alwaysExcludes], [configExcludes]);
  return {
    timer: timerByMinute || fallback.timer,
    excludes,
  };
};
